
import { useState, useCallback } from 'react';
import { DailyHistory, DailyChecklistStatus } from '../types';
import { getTodayDateString } from '../utils/date';
import { INITIAL_TOKENS } from '../constants';

const initialDailyChecklist: DailyChecklistStatus = { clothes: false, bed: false, dressed: false };

export const useDailyState = (initialState: {
  tokens: number;
  history: { [date: string]: DailyHistory };
  questTokenEarnedToday: boolean;
  dailyChecklistCompleted: DailyChecklistStatus;
}) => {
  const [tokens, setTokens] = useState(initialState.tokens);
  const [history, setHistory] = useState(initialState.history);
  const [questTokenEarnedToday, setQuestTokenEarnedToday] = useState(initialState.questTokenEarnedToday);
  const [dailyChecklistCompleted, setDailyChecklistCompleted] = useState(initialState.dailyChecklistCompleted);

  const updateHistory = useCallback((date: string, updates: Partial<DailyHistory>) => {
    setHistory(prev => {
      const todayHistory = prev[date] || { tokens: 0, questsCompleted: [] };
      return { ...prev, [date]: { ...todayHistory, ...updates } };
    });
  }, []);
  
  const handleSpendToken = useCallback((taskKey: string) => {
    if (tokens > 0) {
      const today = getTodayDateString();
      setTokens(t => t - 1);
      
      setHistory(prev => {
          const todayHistory = prev[today] || { tokens: INITIAL_TOKENS, questsCompleted: [] };
          return { ...prev, [today]: { ...todayHistory, tokens: todayHistory.tokens - 1 } };
      });

      if (['clothes', 'bed', 'dressed'].includes(taskKey)) {
        setDailyChecklistCompleted(prev => ({ ...prev, [taskKey]: true }));
      }
    }
  }, [tokens]);

  return {
    tokens,
    history,
    questTokenEarnedToday,
    dailyChecklistCompleted,
    setTokens,
    setHistory,
    setQuestTokenEarnedToday,
    setDailyChecklistCompleted,
    updateHistory,
    handleSpendToken,
  };
};
